import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

function PopoverInfoIcon(props) {
    let color = props.color
    return (
        <div>
            <UncontrolledTooltip
                style={{
                    width: "280px",
                    maxWidth: "300px", textAlign: "left"
                }}
                placement="left" target={`${"UncontrolledTooltipExample"}${props.index}`}>
                <p>{props.textInfo}</p>
                <p>{props.textInfo_2}</p>
                {props.textInfoBreak?.split("'br'")?.map((item) => (<p style={{
                    padding: "0", margin: "0",
                    marginBottom: "2px",
                    textAlign: "left"
                }}>{item}</p>))}
            </UncontrolledTooltip>
            <svg
                style={{ color: color ? color : "#1ea6ec", marginTop: "-3px", cursor: "pointer" }} id={`${"UncontrolledTooltipExample"}${props.index}`}
                xmlns="http://www.w3.org/2000/svg"
                width="18" height="18"
                viewBox="0 0 24 24"
                fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" className="example-popover border-0">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            {" " + props.text}
        </div>
    )
}
export default PopoverInfoIcon;
